export const searchFormColumns = (ctx) => {
  return [
    {
      name: '质权方名称',
      prop: 'pledgeeNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '出质方名称',
      prop: 'pledgorNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
      disabled: ctx.isRenewStatus,
    },
    {
      name: '关联方名称',
      prop: 'relatedNo',
      type: 'searchTableSpec',
      searchType: 'partner',
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    // {
    //   name: '园区公司',
    //   prop: 'parkCompanyNo',
    //   type: 'select',
    //   options: ctx.contractCompanyList,
    // },
    {
      name: '是否逾期',
      prop: 'overdueFlag',
      type: 'select',
      options: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '服务开始时间',
      prop: 'contractValidFrom',
      type: 'date',
    },
    {
      name: '结束时间',
      prop: 'contractValidUntil',
      type: 'date',
    },
    // {
    //   name: '收款时间',
    //   prop: 'lastPaymemtTime',
    //   type: 'date',
    // },
    {
      name: '逾期类型',
      prop: 'alterType',
      type: 'select',
      options: [
        { label: '一次预警', value: '01' },
        { label: '二次预警', value: '02' },
        { label: '到期预警', value: '03' },
      ],
    },
    {
      name: '合同状态',
      type: 'select',
      prop: 'contractStatus',
      options: ctx.contractStatusList,
    },
  ];
};

export const baseColumnListDefault = [
  { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
  {
    field: 'pledgeeName',
    title: '质权方名称',
    width: 120,
  },
  {
    field: 'pledgorName',
    title: '出质方名称',
    width: 120,
  },
  {
    field: 'relatedName',
    title: '关联方名称',
    width: 120,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: 120,
  },
  {
    field: 'contractStatus',
    title: '状态',
    width: 120,
  },
  {
    field: 'contractValidFrom',
    title: '服务开始日期',
    width: 120,
  },
  {
    field: 'contractValidUntil',
    title: '服务结束日期',
    width: 120,
  },
  {
    field: 'overdueFlag',
    title: '是否逾期',
    width: 120,
  },
  {
    field: 'alterType',
    title: '逾期类型',
    width: 120,
  },
  {
    field: 'dueDays',
    title: '到期天数',
    width: 120,
  },
  {
    field: 'expiredDays',
    title: '已逾期天数',
    width: 120,
  },
  {
    field: 'absentInterestRate',
    title: '逾期利率',
    width: 120,
  },
  {
    field: 'overdueExpense',
    title: '逾期费用',
    width: 120,
  },
  {
    field: 'remark',
    title: '备注',
    width: 120,
  },
];
